import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import 'selectize';
import * as moment from 'moment';
import { bookingFormCommon } from "./c005-bookingform-common";
import { bookingFormSubmit } from "./c005-bookingform-submission";
import { bookingFormRedemption } from "./c005-bookingform-redemption";
import { bookingFormInfant } from "./c005-bookingform-infant";
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";
import { wcagOptions } from "./wcag";

export class mobileBookingFormContent {
	private bookingFormSubmit = new bookingFormSubmit();
	private wcag = new wcagOptions();
	private bcommon = new bookingFormCommon();
	$scope:any = $('#mholiday-ibe--container');
  
	$siteCode: string = '';
	$officeCode: string = '';
	$error:Array<string> = [];

	$instance:any;

	$scopeMob: any = $('#mobile-mholidays--container'); // mobile ibe
	// for recent search clicked state to prevent auto focus to the next field with ibe search
	recentSearchActive:boolean = false;
	// value for populating to to location field on from location update complete
	toPrepop:string = null;

	/**
	 * @function bookingNav
	 * !!! Global
	 */
	nav(): void {
		let _self = this;
		let bcommon = _self.bcommon;
		let $deviceHeight = $(window).height()/1.78;

		let $checkInMob: any      = $('#mob-checkin--container');
		let $viewBookingMob: any  = $('#mob-viewbooking--container');
		let $flightStatusMob: any = $('#mob-flightstatus--container');
		let $loginMob: any        = $('#mob-login--container');
		let $loggedinMob: any     = $('#mob-logged-in-user-menu');
		let $mhStayMob: any       = $('#mob-stay--container');
        let $mhUpgradeMob: any    = $('#mob-mhupgrade--container');
		let $mobBookFlight:any    = $('#mobile-bookflight--container');
		let $flightUpgradMob: any    = $('#mob-flightupgrade--container');
		let $moreLinksMob: any 	 = $('#mob-more-links--container');

		let $ibeNavList: any = $('#bookingNav li');
		let $mobIbeNav: any  = $('#mab-bookingnav.mobile #bookingNav');

		let $errorValidationGen:any     = $('.error-validation');
		let $bookingFormTitle:any       = $('.booking-form--title');
		let $dateFormTitle:any          = $('.date-form--title');
		let $bookdateSelectorGen:any    = $('.book-date--selector');
		let $selectizeInputGen:any      = $('.ibe-form--container .selectize-control .selectize-input');
		let $couponCodeGen:any          = $('.couponCode');
		let $redemptionLogin:any        = $('.redemption-login .form-group');

		let $navOverlay: any = $('.mab-nav--overlay');
		let $enrichMobMholidays: any = $('.enrich-revamp .mob-mholidays');

		// array of both mobile ibe links (top nav & side nav)
		let mobileIbeLinks = [$mobIbeNav.find('.mobile-mholiday'), $navOverlay.find('.mobile-mholiday'), $enrichMobMholidays];

		// IBE Navigation show/hide Mobile Check in container
		mobileIbeLinks.map(function($el:any, i:number){
			$el.click(function(){ 
				adobeDataLayer.push('click', {
					'clickName': 'click:tab-click:top-nav-flight-and-hotel',
					'componentType': 'tab',
					'componentName': 'Flight And Hotel Top Menu',
					'componentID': '',
					'attributes': []
				});
				let $fromLocationMobile: any = $('#fromLocationMobile').parent().find('.selectize-control .selectize-input');
				let $toLocationMobile: any = $('#toLocationMobile').parent().find('.selectize-control .selectize-input');
                let curInstance = _self.$instance;
                
				$ibeNavList.removeClass('selected');
				$ibeNavList.find('a.mobile-mholiday').parent().addClass('selected');

				_self.$scopeMob.find('.trip-type--container .returnTrip').addClass('selected');
				_self.$scopeMob.show();
                _self.expandIbe(curInstance);			
				$checkInMob.hide();
				$viewBookingMob.hide();
				$flightStatusMob.hide();
				$mhStayMob.hide();
				$mhUpgradeMob.hide();
				$loginMob.hide();
				$loggedinMob.hide();
				$mobBookFlight.hide();
				$flightUpgradMob.hide();
				$moreLinksMob.hide();
				// form stuff
				$errorValidationGen.hide();
				$bookingFormTitle.removeClass('has-error');
				$dateFormTitle.removeClass('has-error');
				$bookdateSelectorGen.removeClass('has-error');
				$selectizeInputGen.removeClass('has-error');
				$couponCodeGen.removeClass('has-error');
				$redemptionLogin.removeClass('has-error');
				$fromLocationMobile.removeClass('has-error');
				$toLocationMobile.removeClass('has-error');

				bcommon.scrollToTopIBE();


			if(window.innerWidth > 767 && window.innerWidth<1200){
			let $fromLocation:any        =   _self.$scope.find('.mholidays-ibe-from--location');
			let $checkIn:any         = $('#check-in--container');
		    let $viewBooking:any     = $('#view-booking--container');
		    let $flightStatus:any    = $('#flight-status--container');
		    let $login:any           = $('#login-container');
		    let $loggedin:any        = $('#logged-in-user-menu');
			let $fromSelectize:any       =   $fromLocation.parent().find('.selectize-control .selectize-input');
			let $toLocation:any          =   _self.$scope.find('.mholidays-ibe-to--location');
			let $toSelectize:any         =   $toLocation.parent().find('.selectize-control .selectize-input');
			let $mcityToSelectInput:any  =   $('.multi-cityTrip--Container').find('select.mc-to--location');
			let $ibeNav:any;
			if($('.ibe-refresh').length >0) {
				$ibeNav     = $('.desktop #bookingNav');
			}
			else {
				$ibeNav     = $('#bookingNav');
			}
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.mholidays').parent().addClass('selected');
			let $bookingWidget: any  = $('#book-flight--container');
			let $mhStay: any         = $('#ibe-stay--container');
		    let $mhUpgrade: any      = $('#mhupgrade-in--container');
			let curInstance = _self.$instance;
			// desktop stuff
			_self.$scope.show();
			$checkIn.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$login.hide();
			$bookingWidget.hide();
			$loggedin.addClass('hidden');
			let $searchContainer =  _self.$scope.find('.search-container');
		    let $tripTypeContainer =  _self.$scope.find('.trip-container');
		    let $paymentTypeContainer =  _self.$scope.find('.payment-type-container');
		    let $recentContainer =  _self.$scope.find('.recent-container');
		    let $closeBtn =  _self.$scope.find('.close-container');

		$searchContainer.show();
		$searchContainer.parent().addClass('expanded');
		$tripTypeContainer.show();
		$paymentTypeContainer.show();
		$recentContainer.show();
		$closeBtn.find('.close-booking').addClass('expanded');
		
			// mobile stuff
			_self.$scopeMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mhStay.hide();
			$mhUpgrade.hide();

			// form stuff
			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$dateFormTitle.removeClass('has-error');
			$bookdateSelectorGen.removeClass('has-error');
			$fromSelectize.removeClass('has-error');
			$toSelectize.removeClass('has-error');
			$mcityToSelectInput.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
				}
				if ($('.enrich-revamp').length > 0) {
					$('.enrich-revamp .enrich-header').addClass('hide');
					$('.enrich-revamp .enrich-mobile-ibe-container').removeClass('hide');
					_self.expandIbe(_self.$scopeMob);
					let targetHeight: any = $(window).innerHeight() + 'px';
					$('.enrich-revamp #mobile-mholidays--container').css('height', targetHeight);					
				}
			});
		});
	}

	/**
	 * @function init
	 * !!! Global
	 */
	init(): void {
		let _self = this;

		let $bookDateSelector: any = _self.$scopeMob.find('.book-date--selector');
		let $bannerEl:any        = $('.banner-container');
		let $bannerHeight:number = 0;

		let $alertContainer:any  = $('.alert-container');
		let $stickyNavHeight:number;
		let $stickyNavHeightMob:number;

		let $ibeNavList: any = $('#bookingNav li');

		const topNavIbe = $('.mobile#mab-bookingnav [data-mob-mholidays--book-flight]');

		let $passengerDetails:any       = $('[data-mob-mholidays-passenger-details]');
		let $passengerDetailsActive:any = $('[data-mob-mholidays-passenger-details-selected]');

		let $mabHeader:any       = $('#mab-header');

		$passengerDetailsActive.hide();
		$passengerDetails.addClass('passenger-focused');
		$passengerDetails.show();
		$passengerDetails.find('.total-passengers').show();
		$bookDateSelector.removeClass('datepicker-selected');

		// double check in case multiple banners are loaded on page
		$bannerEl.each(function(i:number, el:any){
			 $bannerHeight += $(el).height();
		});

		if ($alertContainer.is(':visible')) {
			$stickyNavHeight = $alertContainer.height() + $mabHeader.height();
			$stickyNavHeightMob = $alertContainer.height() + $mabHeader.height() + $bannerHeight;
		} else {
			$stickyNavHeight = $mabHeader;
			$stickyNavHeightMob = $mabHeader.height() + $bannerHeight;
		}

		// if satisfy conditions on page load open bookflight ibe by default
		// no deeplink detected
		// deeplick detected
		let urlParams = _self.bcommon.getUrlVars(window.location.href);

		let flightHotelTab = _self.$scopeMob.find('input[name="mob_flight_hotel"]');

		flightHotelTab.click(function () {
			let $errorEls = _self.$scopeMob.find('.has-error');
			let $errorValidation = _self.$scopeMob.find('.error-validation').first();

			$errorValidation.hide().find('.mobile-validation--content').empty();
			$errorEls.each(function () {
				$(this).removeClass('has-error');
			});
			let $ibeNowDate: any = new Date();
			let depRange: any;
			let $calDate:any;
			let retRange: any;
			let flightHotelVal = _self.$scopeMob.find('input[name="mob_flight_hotel"]:checked').val();
			if ($('.enrich-revamp').length > 0) {
				_self.$scopeMob.find('input[name="mob_flight_hotel"]').parent().removeClass('active');
				$(this).parent().addClass('active');
			}
			if (flightHotelVal == 'hotel') {
				//	_self.$scopeMob.find('.trip-container').hide();
				_self.$scopeMob.find('.mob-flight-container').hide();
				_self.$scopeMob.find('.mob-hotel-container').show();
				if ($('.mob-hotel-container .departureDate').val() === '') {
					depRange = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + parseInt($('.hotel-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
					_self.$scopeMob.find('.mob-hotel-container .departureDateMobile').datepicker('option', 'maxDate', depRange);
					_self.$scopeMob.find('.mob-hotel-container .returnDateMobile').datepicker('option', 'maxDate', depRange);
				} else {
					$calDate = new Date($('.mob-hotel-container .departureDateMobile').datepicker('getDate'));
					retRange = new Date($calDate.getFullYear(), $calDate.getMonth(), $calDate.getDate() + 14, 0, 0, 0, 0);
					$('.mob-hotel-container .returnDateMobile').datepicker('option', 'maxDate', retRange);
				}
			} else {
				_self.$scopeMob.find('.mob-hotel-container').hide();
				_self.$scopeMob.find('.trip-container').show();
				_self.$scopeMob.find('.mob-flight-container').show();
				if ($('.mob-flight-container .departureDate').val() === '') {
					depRange = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + parseInt($('.flight-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
					_self.$scopeMob.find('.mob-flight-container .departureDateMobile').datepicker('option', 'maxDate', depRange);
					_self.$scopeMob.find('.mob-flight-container .returnDateMobile').datepicker('option', 'maxDate', depRange);
				} else {
					$calDate = new Date($('.mob-flight-container .departureDateMobile').datepicker('getDate'));
					retRange = new Date($calDate.getFullYear(), $calDate.getMonth(), $calDate.getDate() + 14, 0, 0, 0, 0);
					$('.mob-flight-container .returnDateMobile').datepicker('option', 'maxDate', retRange);
				}
			}
		});

	}

	/**
	 * @function setInstance
	 * - set current booking form instance
	 * @param {any} obj - current form object
	 * !!! Properly scoped
	 */
	setInstance(obj:any) {
		let _self = this;
		return _self.$instance = $(obj);
	}

	/**
	 * @function getInstance
	 * retrieve currently assigned booking form instance
	 * @return {any} - current instance
	 */
	getInstance():any {
		let _self = this;
		console.log(_self.$instance);
		return;
	}

	/**
	 * @function passengerType
	 * !!! Properly scoped
	 */
	passengerType(): void {
		let _self = this;

		let $bookDateSelector    = _self.$instance.find('.book-date--selector');
		let $passengerDetails: any        = _self.$instance.find('[data-mob-mholidays-passenger-details]');
		let $passengerDetailsActive: any  = _self.$instance.find('[data-mob-mholidays-passenger-details-selected]');

		let $cabinClass          = _self.$instance.find('.cabinClass');
		let $psngTitleCaption    = $passengerDetailsActive.find('.title-caption');
		let $psngTotalPassengers = $passengerDetailsActive.find('.total-passengers');


		$(document).on('click', function (e:any) {
			if(e.target.name != 'childAgeInput'){
				$passengerDetailsActive.hide();
			}
			if (e.target.parentElement != null) {
				if (e.target.parentElement.name == "room_close3" || e.target.parentElement.name == "room_close2" || e.target.parentElement.innerText == "Add Room ") {
					$passengerDetailsActive.show();
					e.stopPropagation();
					$bookDateSelector.removeClass('datepicker-selected');
				}
			}

		});

		$passengerDetails.click(function(e:any) {
			$passengerDetailsActive.show();
			e.stopPropagation();
			$bookDateSelector.removeClass('datepicker-selected');
		});

		$('.mob-mholiday-passengers .add_rooms').click(function(e:any) {
			$passengerDetailsActive.show();
			e.stopPropagation();
			$bookDateSelector.removeClass('datepicker-selected');
		});
		$('.mob-mholiday-passengers .close-bookingroom2').click(function(e:any) {
			$passengerDetailsActive.show();
			e.stopPropagation();
			$bookDateSelector.removeClass('datepicker-selected');
		});
		$('.mob-mholiday-passengers .close-bookingroom3').click(function(e:any) {
			$passengerDetailsActive.show();
			e.stopPropagation();
			$bookDateSelector.removeClass('datepicker-selected');
		});

		$passengerDetailsActive.on('mouseleave', function () {
			// $(this).hide();
		}).find('button, input').on('click', function (evt:any) {
			evt.stopPropagation();
		});
		


		let $psngEls = [$psngTitleCaption, $psngTotalPassengers, $cabinClass];

		$.each($psngEls, function(index:number, el:any ) {
			el.click(function(){
				$passengerDetailsActive.hide();
				$passengerDetails.addClass('passenger-focused');
				$passengerDetails.show();
				$passengerDetails.find('.total-passengers').show();
				$bookDateSelector.removeClass('datepicker-selected');
			});
		});
	}

/**
	 * @function recentSearch
	 * [recentSearch description]
	 * !!! Properly scoped
	 */
	recentSearch(): any {
		let _self = this;
		let $searchContainer = _self.$instance.find('.search-container');
		
		_self.$instance.find('.search-content').each(function(){
			let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
			let $searchItem = $(this);

			$searchItem.on('click', function(){
				let $fromCityCode: any     = $searchItem.find('.from-city--code').html();
				let $toCityCode: any       = $searchItem.find('.to-city--code').html();
				let $recentDepartDate: any = $searchItem.find('.from-date').attr('data-departDate');
				let $recentReturnDate: any = $searchItem.find('.to-date').attr('data-returndate');
				let $totalPassengersVal: any = $searchItem.find('.total-psngr').val();
				let $cabinClassVal: any	   = $searchItem.find('.cabin-hidden').val();
				let $cabinClass: any       = curInstance.find('.cabin-class-mob');
				let $fromLocation: any     = curInstance.find('.ibe-mob-from--location');
				let $toLocation: any       = curInstance.find('.ibe-mob-to--location');
				let $bookdateSelector:any  = curInstance.find('.book-date--selector');
				let $depRetTitle: any      = curInstance.find('.dep-return--title');
				let $totalPassenger: any   = curInstance.find('.total-passengers');
				let $passengerSplit: any   = curInstance.find('.booking-category');
				
				_self.recentSearchActive = true;
				/* Recent search - Check one way*/
				let $deptDateExist:any = $searchItem.find('.date .to-date');
				let $getTripType:any = curInstance.find('.trip-type--container');
				let $passengerValArr:any;

				if (!$deptDateExist.length){
					$getTripType.find('.oneWayTrip').trigger('click');
				} else {
					$getTripType.find('.returnTrip').trigger('click');
				}

				$searchContainer.show();
				$('.evo-autocomplete--static-mob').hide();

				// assign "to location" value to prepop into class variable
				// (to await completion of updating "from location")
				// following which the "to location" value will be populated
				//_self.toPrepop = $toCityCode;
				
			//	_self.toCityFromCookie = $toCityCode;
				if($totalPassengersVal === "undefined"||undefined)
				{
					$totalPassengersVal = "1|0|0|0";
				}

				$passengerValArr = $totalPassengersVal.split("|");
				$totalPassenger.find('.total-nos').html($passengerValArr[0]);
				$passengerSplit.find('.ticket-adult--input').val($passengerValArr[1]);
				$passengerSplit.find('.ticket-child--input').val($passengerValArr[2]);
				$passengerSplit.find('.ticket-infant--input').val($passengerValArr[3]);
				
				$cabinClass[0].selectize.setValue($cabinClassVal);
				$fromLocation[0].selectize.setValue($fromCityCode);
				$toLocation[0].selectize.setValue($toCityCode);
				$depRetTitle.find('.date-form--title').addClass('input-filled');
				$bookdateSelector.find('.departureDateMobile').val($recentDepartDate);
				$bookdateSelector.find('.returnDateMobile').val($recentReturnDate);

				setTimeout(function() {
					_self.recentSearchActive = false;
				}, 1000);
			});
			
			$searchItem.find('a.close-recent--item').on('click', function(){
				$searchItem.remove();
			});
		});
	}	/**
	 * @function ibeTripType
	 * !!! Properly scoped
	 */
	ibeTripType(): void {
		let _self = this;

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		let returnDate = '';

		// return trip click event (mobile)
		curInstance.find('.trip-type--container .returnTrip').click(function(){
			returnTripClickHandler(this, curInstance);
		});

		// one way trip click event (mobile)
		curInstance.find('.trip-type--container .oneWayTrip').click(function(){
			oneWayTripClickHandler(this, curInstance);
		});

		/*
		* return trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function returnTripClickHandler(el:any, instance:any) {
			let bdsRetTrip: any = instance.find('.book-date--selector.returnTrip');
			let bdsOneTrip: any = instance.find('.book-date--selector.oneWayTrip');
			let mobReturnTripDepartureDate:any = instance.find('.departureDateMobile');

			// clear select state on all trip type selectors
			$(el).parent().find('li').removeClass('selected');
			$(el).addClass('selected');

			// toggle display of OnD fields
			bdsRetTrip.show();
			bdsOneTrip.hide();
			instance.find('.location-container.single-cityTrip--Container').show();

			// remove filled state on input labels
			bdsRetTrip.find('.dep-return--title .dep-title').removeClass('input-filled');
			bdsRetTrip.find('.dep-return--title .ret-title').removeClass('input-filled');

			// empty input field
			//bdsRetTrip.find('.departureDateMobile').removeClass('date-filled').val('');
			//bdsRetTrip.find('.returnDateMobile').removeClass('date-filled').val('');
			if (returnDate != '') {
				bdsRetTrip.find('.returnDateMobile').val(returnDate);
			}

			mobReturnTripDepartureDate.datepicker('setDate', $('#oneWayTripDateSelectorMob').find('.departureDateMobile').val()).trigger('blur', 'input');
		}

		/**
		* one way trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function oneWayTripClickHandler(el:any, instance:any) {
			let bdsRetTrip: any = instance.find('.book-date--selector.returnTrip');
			let bdsOneTrip: any = instance.find('.book-date--selector.oneWayTrip');
			let mobOneWayTripDepartureDate = instance.find('.departureDateMobile');

			// clear select state on all trip type selectors
			$(el).parent().find('li').removeClass('selected');
			$(el).addClass('selected');

			// toggle display of OnD fields
			bdsRetTrip.hide();
			bdsOneTrip.show();
			instance.find('.location-container.single-cityTrip--Container').show();

			// remove filled state on input labels
			bdsRetTrip.find('.dep-return--title .dep-title').removeClass('input-filled');
			bdsRetTrip.find('.dep-return--title .ret-title').removeClass('input-filled');

			// empty input field
			//bdsRetTrip.find('.departureDateMobile').removeClass('date-filled').val('');
			//bdsRetTrip.find('.returnDateMobile').removeClass('date-filled').val('');
			returnDate = bdsRetTrip.find('.returnDateMobile').val();
			bdsRetTrip.find('.returnDateMobile').val('');

			// Retain the departure date selected for return trip
			mobOneWayTripDepartureDate.datepicker('setDate', $('#returnTripDateSelectorMob').find('.departureDateMobile').val()).trigger('blur', 'input');
		}

		// redemption submit button handlers
		let tripTypeContainer:any   = _self.$instance.find('.trip-type--container');
		let rdmSingleSubmitBtn:any = _self.$instance.find('.redemption-submit-btn-single');
		let rdmMultiSubmitBtn:any  = _self.$instance.find('.redemption-submit-btn-multi');

		rdmMultiSubmitBtn.hide();

		tripTypeContainer.find('.returnTrip').on('click', () => {
			rdmSingleSubmitBtn.show();
			rdmMultiSubmitBtn.hide();
		});

		tripTypeContainer.find('.oneWayTrip').on('click', () => {
			rdmSingleSubmitBtn.show();
			rdmMultiSubmitBtn.hide();
		});
	}


	/**
	 * expand this instance of ibe
	 * extrapolate method so that it can be used elsewhere
	 * instead of just selectize.focus()
	 * @author dominic <dominic.gan@mirumagency.com>
	 */

	expandIbe(instance:any):void {
		let $mobileBookFlightContainer: any = instance;
		let $showMobileCloseBtn:any = $mobileBookFlightContainer.find('.close-container .close-booking');
		let $showMobileToLocation:any = $mobileBookFlightContainer.find('.toLocation');
		let $showMobilePaymentContainer:any = $mobileBookFlightContainer.find('.payment-type-container');
		let $showMobileTripContainer:any = $mobileBookFlightContainer.find('.trip-container');
		let $showMobileSearchContainer:any = $mobileBookFlightContainer.find('.search-container');

		$mobileBookFlightContainer.addClass('expanded');
		$showMobileCloseBtn.addClass('expanded');
		$showMobileSearchContainer.show();
		$showMobileToLocation.show();
		$showMobilePaymentContainer.show();
		$showMobileTripContainer.show();
	}

	/**
	 * @function initSelectize
	 * @param {any} listItems [description]
	 * !!! Properly scoped
	 */
	initSelectize(listItems:any): void {
		let _self = this;
		let bcommon = _self.bcommon;

		let $fromLocationMobile:any = _self.$instance.find('.ibe-mob-from--location');
		let $toLocationMobile:any   = _self.$instance.find('.ibe-mob-to--location');
		let $toLocationMobileById:any     = _self.$instance.find('#ibeToLocationMobile');

		let $returnTripDateSelectorMobById:any     = _self.$instance.find('#returnTripDateSelectorMob');
 		let $oneWayTripDateSelectorMobById:any     = _self.$instance.find('#oneWayTripDateSelectorMob');

		let $fromLocationMobTitle:any       = $fromLocationMobile.parent().find('.booking-form--title');
		let $fromLocationSelectizeInput:any = $fromLocationMobile.parent().find('.selectize-control .selectize-input');

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let $cugParam:any = $('#search-param-cug').val();
		let $studentPortalDashboard:boolean =false;
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if(studentEnrichIdCookieVal != null && studentDashboard != null){
			$studentPortalDashboard  = true;
		}
		let $recentHide:any =false;
		$fromLocationMobile.html(listItems);
			/**
		 * [getCookieByMatch description]
		 * @param {string} regex [description]
		 */
		function getCookieByMatch(regex:RegExp) {
			let cs:any = document.cookie.split(/;\s*/),
					ret:Array<any> = [];
			for (var i:number = 0; i < cs.length; i++) {
				if (cs[i].match(regex)) {
					ret.push(cs[i]);
				}
			}
			return ret ;
		}
		$fromLocationMobile.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($fromLocationMobile[0].selectize);
			},
			onFocus: function() {
				$fromLocationMobTitle.addClass('input-filled');
				$fromLocationSelectizeInput.addClass('select-filled');
				$fromLocationSelectizeInput.removeClass('has-error');
				$fromLocationMobTitle.removeClass('has-error');
				let $fromLocationChange = $fromLocationMobile.find('option:selected').text();
				let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);

				if (recentSearchCookieArr.length > 0 && $cugParam !="CUG" && $studentPortalDashboard == false) {
					$(".ibe-mob-from--location .selectize-dropdown .selectize-dropdown-content").show();
					$('.evo-autocomplete--static-mob').hide();
				}
			},
			onDropdownOpen: function ($dropdown:any) {
			},
			onChange: function() {
				$fromLocationMobTitle.addClass('input-filled');
				$fromLocationSelectizeInput.addClass('select-filled');
				let ibeFromLocationValMobile = $fromLocationMobile.val().trim();
				let cashFlowType = curInstance.find('input[name="cash_miles_type"]:checked').val();

				_self.bcommon.updateMholidaysOnDListOnFlowChange("mholiday", ibeFromLocationValMobile, $toLocationMobile);
		
				if (ibeFromLocationValMobile != "" && !_self.recentSearchActive) {
					setTimeout(function() {
						$toLocationMobileById.find('input[type="select-one"]').focus();
						$toLocationMobTitle.addClass('input-filled');
						$toLocationSelectizeInput.addClass('select-filled');
					}, 300);
				}
				_self.expandIbe(curInstance);
			},
			onBlur: function(){
				let $fromLocationChange = $fromLocationMobile.find('option:selected').text();
				if($recentHide == false){
					$('.evo-autocomplete--static-mob').hide(); 
					}
				if ($fromLocationChange == ''){
					$fromLocationMobTitle.removeClass('input-filled');
					$fromLocationSelectizeInput.removeClass('select-filled');
				} else {
					$fromLocationMobTitle.addClass('input-filled');
					$fromLocationSelectizeInput.addClass('select-filled');
				}
				$recentHide = false;
			},
			searchField: ['text', 'optgroup'],
			selectOnTab: true
		});
		
		$(".ibe-mob-from--location").keydown(function(event: any) {
			if (event.keyCode === 9) {
				event.preventDefault();
				event.stopPropagation();
			}
		});

		
		$("#mobile-mholidays--container .ibe-mob-from--location .selectize-input input").keyup(function(){ 
			//let $fromLocationChange = $ibeFromLocation.find('option:selected').text();
			let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);

			if (recentSearchCookieArr.length > 0 && $cugParam!= "CUG" && $studentPortalDashboard == false) {
				if ($(".ibe-mob-from--location .selectize-input input").val() == '') {
				//	$('.evo-autocomplete--static-mob').show();
					$(".ibe-mob-from--location .selectize-dropdown .selectize-dropdown-content").show();
				}else{
					$('.evo-autocomplete--static-mob').hide();
					$(".ibe-mob-from--location .selectize-dropdown .selectize-dropdown-content").show();
				}
			}
		});
		$toLocationMobile.html(listItems);

		let $toLocationMobTitle:any       = $toLocationMobile.parent().find('.booking-form--title');
		let $toLocationSelectizeInput:any;

		$toLocationMobile.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($toLocationMobile[0].selectize);
				$toLocationSelectizeInput = $toLocationMobile[0].selectize.$control;
			},
			onFocus: function() {
				$toLocationMobTitle.addClass('input-filled');
				$toLocationSelectizeInput.addClass('select-filled');
				$toLocationSelectizeInput.removeClass('has-error');
				$toLocationMobTitle.removeClass('has-error');
			},
			onDropdownOpen: function ($dropdown:any) {
			},
			onChange: function(value: any){
				$toLocationMobTitle.addClass('input-filled');
				$toLocationSelectizeInput.addClass('select-filled');
				// show error if from and to fields are the same and not empty
				if ($fromLocationMobile.val() === $toLocationMobile.val() && $fromLocationMobile.val().length > 0) {
					$toLocationSelectizeInput.addClass('has-error');
					$toLocationMobTitle.addClass('has-error');
				}
				else {
					$toLocationSelectizeInput.removeClass('has-error');
					$toLocationMobTitle.removeClass('has-error');
				}
				if ($toLocationMobile.val().trim() != "" && !_self.recentSearchActive) {
					setTimeout(function() {
						if(!$('#oneWayTripDateSelectorMob').is(':visible')) {
							if ( $('#returnTripDateSelectorMob').find('.departureDateMobile').val()=='') {
								$returnTripDateSelectorMobById.find('input[name="ReturnTripStartMobile"]').focus();
							}
						} else {
							if ( $('#oneWayTripDateSelectorMob').find('.departureDateMobile').val()=='') {
								$oneWayTripDateSelectorMobById.find('input[name="OneWayTripMobile"]').focus();
							}
						}
					}, 200);
				}
				
			},
			onBlur: function(){
				let $toLocationChange = $toLocationMobile[0].selectize.$input.val();
				if (!$toLocationChange.length){
					$toLocationMobTitle.removeClass('input-filled');
					$toLocationSelectizeInput.removeClass('select-filled');
				} else {
					$toLocationMobTitle.addClass('input-filled');
					$toLocationSelectizeInput.addClass('select-filled');
				}
			},
			onLoad: function(data:any) {
				_self.fillToPrepopValue($toLocationMobile[0].selectize);
				$toLocationMobile[0].selectize.trigger('blur');
			},
			searchField: ['text', 'optgroup'],
			selectOnTab: true
		});

		let $cabinSelected:any = _self.$instance.find('.cabin-class-mob');
		$cabinSelected.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($cabinSelected[0].selectize);
				// set economy as default on load
				$cabinSelected[0].selectize.setValue('CFFECO');
			},
			onFocus: function() {
				$cabinSelected.parent().find('.booking-form--title').addClass('input-filled');
				curInstance.find('.cabin-class-mob.selectize-control.single .selectize-input').addClass('select-filled');
			},
			onChange: function() {
				$cabinSelected.parent().find('.booking-form--title').addClass('input-filled');
				curInstance.find('.cabin-class-mob.selectize-control.single .selectize-input').addClass('select-filled');
			},
			onBlur: function(){
				let $cabinClassChange = $cabinSelected.find('option:selected').text();
				if ($cabinClassChange == ''){
					$cabinSelected.parent().find('.booking-form--title').removeClass('input-filled');
					curInstance.find('.cabin-class-mob.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$cabinSelected.parent().find('.booking-form--title').addClass('input-filled');
					curInstance.find('.cabin-class-mob.selectize-control.single .selectize-input').addClass('select-filled');
				}
			}
		});
	}

	/**
	 * @function calendarComponent
	 * !!! Properly scoped
	 */
	calendarComponent(): void {
		let _self = this;
		let bcommon = _self.bcommon;

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		let nowDate:any      = new Date();
		let today:any        = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
		let $ibeMHHMindays: any = $('[data-mhh-min-days]').length > 0 ? parseInt($('[data-mhh-min-days]').attr('data-mhh-min-days')) : 7;
		let tomorrow:any        = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + $ibeMHHMindays, 0, 0, 0, 0);
		let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
		let maxLimitDate: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + maxDays, 0, 0, 0, 0);
		
		let depRange: any;
		let flightHotelVal = curInstance.find('input[name="mob_flight_hotel"]:checked').val();
		if (flightHotelVal == 'hotel') {
			depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('.hotel-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
		}
		else {
			depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('.flight-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
		}
        let retRange: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 14, 0, 0, 0, 0);

		let $curDatepickerInst:any;
		let $curDatepickerTitle:string;

		let $deviceHeight = $(window).height()/1.78;

		function highlightMobileDays(date: any) {
			var startDate = new Date(curInstance.find('.departureDateMobile').datepicker('getDate'));
			var endDate = new Date(curInstance.find('.returnDateMobile').datepicker('getDate'));

			if ((startDate <= date) &&  (date <= endDate)) {
				return [true, 'highlight'];
			} else {
				return [true, ''];
			}
		}

		$(function() {
			let $dateFormat: any = 'd M yy',
			$departDate = curInstance.find('.departureDateMobile')
			.datepicker({
				showButtonPanel: true,
				closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
				minDate: tomorrow,
				dateFormat: 'd M yy',
				maxDate: depRange,
				numberOfMonths: 2,
				firstDay: 1,
				onClose: function(selectedDate: any) {
					let nextDay:any = new Date(selectedDate);
					nextDay.setDate(nextDay.getDate() + 1);
					let depDate = getDate(this);
					depDate = depDate ? depDate : nowDate;
					let flightHotelVal = curInstance.find('input[name="mob_flight_hotel"]:checked').val();
					if (flightHotelVal == 'hotel') {
						depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('.hotel-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
						$('.mob-hotel-container .returnDateMobile').datepicker("option", "minDate", ((selectedDate && selectedDate!='') ? nextDay : tomorrow));
					}
					else {
						depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('.flight-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
						$('.mob-flight-container .returnDateMobile').datepicker("option", "minDate", ((selectedDate && selectedDate!='') ? nextDay : tomorrow));
					}
					
					if(selectedDate=='') {
						$('.returnDateMobile').datepicker('option', 'maxDate', depRange);
					} else {
						$('.returnDateMobile').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + 14, 0, 0, 0, 0));
					}
				},
				beforeShow: function(ele:any, obj:any) {
					$curDatepickerInst = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
				},
				afterShow: function() {
					bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				}
			})

			.on('change', function() {
				//$returnDate.datepicker('option', 'minDate', getDate(this));
				$returnDate.datepicker('setDate', null);
				window.setTimeout($.proxy(function() {
					$(this).next('.returnDateMobile').focus();
				}, this), 100);
			}),

			$returnDate = curInstance.find('.returnDateMobile').datepicker({
				showButtonPanel: true,
				closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
				dateFormat: 'd M yy',
				minDate: tomorrow,
				maxDate: depRange,
				numberOfMonths: 2,
				firstDay: 1,
				beforeShow: function(ele:any, obj:any) {
					$curDatepickerInst = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
				},
				afterShow: function() {
					bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				}
			})
			.on('change', function() {				
				curInstance.find('[data-mob-mholidays-passenger-details-selected]').show();
			});

			function getDate($element: any) {
				let $getDate: any;
				try {
					$getDate = $.datepicker.parseDate($dateFormat, $element.value);
				} catch(error) {
					$getDate = null;
				}
				return $getDate;
			}
		});

		$('#ui-datepicker-div').on('mouseover','td',function() {
			if (curInstance.find('.trip-type--container .returnTrip').hasClass('selected')){
				if (curInstance.find('.departureDateMobile').val()){
					$(this).parent().addClass("finalRow");
					//ugly traversing
					var parent = $(this).parent(); //tr
					var parentParent = $(parent).parent(); //tbody
					var parentParentParent = $(parentParent).parent(); //table
					var parentParentParentParent = $(parentParentParent).parent(); //div

					curInstance.find('.finalRow').prevAll().find('td:not(.ui-datepicker-unselectable)').addClass('highlight');
					$(this).prevAll('td:not(.ui-datepicker-unselectable)').addClass('highlight');

					//check if selecting on last cal
					if ($(parentParentParentParent).hasClass("ui-datepicker-group-last")) {
						curInstance.find('.ui-datepicker-group-first td:not(.ui-datepicker-unselectable)').addClass('highlight');
					}
				}
			}
		});

		curInstance.find('.departureDateMobile.oneway-trip').datepicker({
			showButtonPanel: true,
			closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
			minDate: today,
			dateFormat: 'd M yy',
			beforeShowDay: highlightMobileDays,
			maxDate: maxLimitDate,
			numberOfMonths: 2,
			firstDay: 1,
			beforeShow: function(ele:any, obj:any) {
				$curDatepickerInst = obj.dpDiv[0];
				$curDatepickerTitle = ele.dataset.datepickerTitle;
			},
			afterShow: function() {
				bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
			}
		});
	}

	/**
	 * @function passengerDetailsHotel
	 * !!! Properly scoped
	 */
	passengerDetailsHotel(): void {
		let _self = this;
		let $ticketAdultInput:number   = 1;
		//let $ticketYouthInput:number = 0;
		let $ticketChildInput:number   = 0;
		let $ticketInfantInput:number  = 0;
		let $totalTickets:number       = 1;
		let $totalPassenger:any 	  = _self.$instance.find('.mob-hotel-container .total-passengers');
		// adding room count
		let $ticketAdultInput_roomf:number  = 1;
		let $ticketAdultInput_rooms:number  = 1;
		let $ticketAdultInput_roomt:number  = 1;
		let $ticketChildInput_roomf:number  = 0;
		let $ticketChildInput_rooms:number  = 0;
		let $ticketChildInput_roomt:number  = 0;
		let $ticketInfantInput_roomf:number  = 0;
		let $ticketInfantInput_rooms:number  = 0;
		let $ticketInfantInput_roomt:number  = 0;

		let curInstance = _self.$instance.find('.mob-hotel-container'); // assign current instance to var as later requests will call latest assigned instance
		let $groupBooking     = curInstance.find('.group-booking');

		$totalPassenger.find('.total-nos').html($totalTickets);
		_self.$instance.find('.mob-hotel-container input.total-tickets--value').val($totalTickets);

		$('.mob-hotel-container .close-bookingroom_hotelmob2').on('click', () => {
				if ($("#roomthre_hotelmob_details").css('display') == 'none')
				{
					$('#roomtwo_hotelmob_details').css({ 'display': 'none' });
					$('.mob-hotel-container .ticket-mob-adult--input2').val('0');
					$('.mob-hotel-container .ticket-infant--input2').val('0');
					$('.mob-hotel-container .ticket-mob-child--input2').val('0');
					$('#roomtwo_hotelmob_details').find('.booking-ticket--nosr').remove();
					$('.mob-hotel-container .close-bookingroom_hotelmob2').addClass('hide');
					updatemobHotelTicketQtys();
				}
				$('.mob-hotel-container .add_roomshotel').show();
			});
			$('.mob-hotel-container .close-bookingroom_hotelmob3').on('click', () => {
				$('#roomthre_hotelmob_details').css({'display': 'none' });
				$('.mob-hotel-container .add_roomshotel').show();
				$('.mob-hotel-container .ticket-mob-adult--input3').val('0');
				$('.mob-hotel-container .ticket-infant--input3').val('0');
				$('.mob-hotel-container .ticket-mob-child--input3').val('0');
				$('#roomthre_hotelmob_details').find('.booking-ticket--nosr').remove();
				$('.mob-hotel-container .close-bookingroom_hotelmob2').removeClass('hide');
				updatemobHotelTicketQtys();
			});

			_self.$instance.find('.mob-hotel-container .add_roomshotel').on('click', function(e:any) {
				e.preventDefault();
				if ($("#roomtwo_hotelmob_details").css('display') == 'none')
				{
					$('#roomtwo_hotelmob_details').css({'display': 'block' });;
					$('#roomtwo_hotelmob_details').removeClass('hide');
					$('.ticket-mob-adult--input2').val('1');
					$('.mob-hotel-container .close-bookingroom_hotelmob2').removeClass('hide');
					curInstance.find('.booking-ticket--nos .age-label').show();
					_self.$instance.find('[data-mob-mholidays-passenger-details-selected]').show();
					updatemobHotelTicketQtys();
				}
				else
				{
					$('#roomthre_hotelmob_details').removeClass('hide');
					$('#roomthre_hotelmob_details').css({'display': 'block' });;
					curInstance.find('.booking-ticket--nos .age-label').show();
					$('.mob-hotel-container .close-bookingroom_hotelmob2').addClass('hide');
					$('.ticket-mob-adult--input3').val('1');
					$('.mob-hotel-container .add_roomshotel').hide();
					updatemobHotelTicketQtys();
				}

			});
		_self.$instance.find('.mob-hotel-container .mobile-ticketnos--btn').on('click', function(e:any){
			e.preventDefault();
			let $passengerDetailsActive:any = curInstance.find('[data-mob-mholidays-passenger-details-selected]');

			// declare passenger input variables
			// scope them to prevent multiple elements from being retrieved
			// (deals component uses the same class name for its inputs)
			let $adultInput  = $passengerDetailsActive.find('.ticket-mob-adult--input');
			let $infantInput = $passengerDetailsActive.find('.ticket-mob-infant--input');
			let $childInput = $passengerDetailsActive.find('.ticket-mob-child--input');
			// let $youthInput  = _self.$passengerDetailsActive.find('.ticket-mob-youth--input');

			let $adultBookingErr  = curInstance.find('.adult-booking--error---mobile');
			let $infantBookingErr = curInstance.find('.infant-booking--error---mobile');


			// get currently acted on input field
			var fieldName   = $(this).attr('data-field'),
			type        = $(this).attr('data-type'),
			input       = curInstance.find("input[name='"+fieldName+"']"),
			currentVal   = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
				if (type == 'minus') {
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
					}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
				} else if (type == 'plus') {
					if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
					}
					if (parseInt(input.val()) == input.attr('max')) {
						$(this).attr('disabled', true);
					}
				}
			} else {
				input.val(0);
			}
			if (!isNaN(currentVal) && fieldName=="passengersChildren"||fieldName=="passengersChildren2"||fieldName=="passengersChildren3") {
				// show age box if hide
				let room_var=fieldName;
				var currentChild = currentVal+1;
				var currentChildmnus = currentVal-1;
				//flight-container
				$('.mob-hotel-container .child-age-grp'+room_var).show();
				// $('.mob-flight-container .child-age-grp').show();
				if (type == 'minus') {
					if(currentChildmnus%8 ==0){
						$( ".mob-hotel-container #child-age-col"+room_var+currentChildmnus ).remove();
						// $( ".mob-hotel-container #child-age-col"+currentChildmnus ).remove();

					}else{
						//Append box
						$('.mob-hotel-container #child-age-select'+room_var+currentVal).empty();
						// $('.mob-flight-container #child-age-select'+currentVal).empty();
					}
				} else if (type == 'plus') {
					if(currentVal%8 ==0){
						// Append column
						let ageLabel ='';
						let errorChildAge ='';
						if(currentChild == 1){
							ageLabel ='Age';
							errorChildAge ='<div class="child-age-error" data-childage-limit-mob="Child age must be between 2 and 12" data-childage="Child age is missing" style="display: none;">Please enter child age</div>';
						}
						var col1 =currentChild;
						var col2 =currentChild+1;
						var col3 =currentChild+2;
						var col3 =currentChild+2;
						var col4 =currentChild+3;
						var col5 =currentChild+4;
						var col6 =currentChild+5;
						var col7 =currentChild+6;
						var col8 =currentChild+7;
						var col9 =currentChild+9
						let $childAgeList ='<div class="col-lg-12 col-md-12 col-sm-12" id="child-age-col'+room_var+currentVal+'">'
						+'<div class="col-lg-12 col-md-12 col-sm-12 booking-ticket--nosr adult-nos child-age-drp"> <div class="child-age-label">Age of Children/Teenager</div>'
						+ errorChildAge
						+'	<div class="row" id="child-age-select'+room_var+col1+'">'
						+'	</div>'
						+'	<div class="row" id="child-age-select'+room_var+col2+'"> '
						+'	</div>'
						+'	<div class="row" id="child-age-select'+room_var+col3+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col4+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col5+'"> '
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col6+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col7+'"> '
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col8+'">'
						+'	</div>'
						+'	<div class="row " id="child-age-select'+room_var+col9+'">'
						+'	</div>'
						+'</div>'
						+' </div>'
						
						// $('.mob-flight-container #child-age-grp').append($childAgeList);	
						// $('.mob-flight-container #child-age-select'+currentChild).('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('.mob-hotel-container #child-age-grp'+room_var).append($childAgeList);	
						$('.mob-hotel-container #child-age-select'+room_var+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child/Teenager '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					}else{
						//Append box
						// $('.mob-flight-container #child-age-select'+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('.mob-hotel-container #child-age-select'+room_var+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child/Teenager '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="2" selected>2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
					}
				}
				else{
					$('.mob-hotel-container #child-age-select'+room_var+currentChild).append('');
				}
			}
		});

		// disable user input on field (next statement will no longer have any effect)
			curInstance.find('.minus-plus-input').attr('readonly', true);
		// store current value of input to data-attribute on focus
		// in case user manually edits fields
			_self.$instance.find('.mob-hotel-container .minus-plus-input').focusin(function(){
				$(this).data('oldValue', $(this).val());
			});

		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('.mob-hotel-container .minus-plus-input').on('change', function() {
			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');
				if (valueCurrent >= minValue) {
					curInstance.find(".mobile-ticketnos--btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
				} else {
				$(this).data('oldValue',$(this).val());
				}
				if (valueCurrent <= maxValue) {
					curInstance.find(".mobile-ticketnos--btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
				} else {
				$(this).data('oldValue',$(this).val());
				}
				updatemobHotelTicketQtys();
			});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
			_self.$instance.find('.mob-hotel-container .minus-plus-input').keydown(function (e:any) {
				if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
					(e.keyCode == 65 && e.ctrlKey === true) ||
					(e.keyCode >= 35 && e.keyCode <= 39)) {
					return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});
		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		updatemobHotelTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updatemobHotelTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[data-mob-mholidays-passenger-details-selected]');

			$ticketAdultInput_roomf = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input').val());
			$ticketAdultInput_rooms = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input2').val());
			$ticketAdultInput_roomt = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input3').val());
			$ticketChildInput_roomf = parseInt($passengerDetailsActive.find('.ticket-mob-child--input').val());
			$ticketChildInput_rooms = parseInt($passengerDetailsActive.find('.ticket-mob-child--input2').val());
			$ticketChildInput_roomt = parseInt($passengerDetailsActive.find('.ticket-mob-child--input3').val());
			$ticketInfantInput_roomf = parseInt($passengerDetailsActive.find('.ticket-infant--input').val());
			$ticketInfantInput_rooms = parseInt($passengerDetailsActive.find('.ticket-infant--input2').val());
			$ticketInfantInput_roomt = parseInt($passengerDetailsActive.find('.ticket-infant--input3').val());	
			// get current values in input field and assign to method vars
			$ticketAdultInput = $ticketAdultInput_roomf +$ticketAdultInput_rooms + $ticketAdultInput_roomt;
			$ticketInfantInput = $ticketInfantInput_roomf +$ticketInfantInput_rooms + $ticketInfantInput_roomt;
			$ticketChildInput = $ticketChildInput_roomf +$ticketChildInput_rooms + $ticketChildInput_roomt;


			// only adult, teenager and child tickets count towards limit
			$totalTickets = $ticketAdultInput + $ticketInfantInput + $ticketChildInput;

			let $totalPassengersVal:any = $totalTickets;
			//let $totalPassenger:any 	  = curInstance.find('.total-passengers');
			let $totalTravelerDisplay:any = curInstance.find('.total-passengers');

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('#mobile-mholidays--container .total-tickets--value').val($totalTickets);
			//$totalPassenger.find('.total-nos').html($totalPassengersVal);
			//$totalPassenger.find('.total-nos').html($totalPassengersVal);
			$('.mob-hotel-mholiday-passengers .total-nos').html($totalPassengersVal);

			if ($totalTickets >= 2) {
				$totalTravelerDisplay.find('.type').html('Travellers');
			} else {
				$totalTravelerDisplay.find('.type').html('Traveller');
			}

			
			// infant validations

			if($ticketInfantInput==3)
			{
				curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
			}
			else
			{
					if ($ticketAdultInput_roomf == $ticketInfantInput_roomf) 
					{
						$('#roomone_details_hotelmob').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_roomf <$ticketInfantInput_roomf)
					{
						$('#roomone_details_hotelmob').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomone_details_hotelmob').find('.ticket-infant--input').val($ticketAdultInput_roomf);
					}
					else
					{
						$('#roomone_details_hotelmob').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}

					if ($ticketAdultInput_rooms == $ticketInfantInput_rooms) 
					{
						$('#roomtwo_hotelmob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_rooms <$ticketInfantInput_rooms)
					{
						$('#roomtwo_hotelmob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomtwo_hotelmob_details').find('.ticket-infant--input').val($ticketAdultInput_rooms);
					}
					else
					{
						$('#roomtwo_hotelmob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}


					if ($ticketAdultInput_roomt == $ticketInfantInput_roomt) 
					{
						$('#roomthre_hotelmob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_roomt <$ticketInfantInput_roomt)
					{
						$('#roomthre_hotelmob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomthre_hotelmob_details').find('.ticket-infant--input').val($ticketAdultInput_roomt);
					}
					else
					{
						$('#roomthre_hotelmob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}
				}
				
				// adult validations

				let $totalTickets_room1:number = $ticketAdultInput_roomf  + $ticketChildInput_roomf;
				let $totalTickets_room2:number = $ticketAdultInput_rooms  + $ticketChildInput_rooms;
				let $totalTickets_room3:number = $ticketAdultInput_roomt  + $ticketChildInput_roomt;

				if($totalTickets_room1==9)
				{
				$('#roomone_details_hotelmob').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				$('#roomone_details_hotelmob').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}
				else
				{
				$('#roomone_details_hotelmob').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				$('#roomone_details_hotelmob').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
				 if($totalTickets_room2==9)
				{
					$('#roomtwo_hotelmob_details').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
					$('#roomtwo_hotelmob_details').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}

				else
				{
					$('#roomtwo_hotelmob_details').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
					$('#roomtwo_hotelmob_details').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
				if($totalTickets_room3==9)
				{
					$('#roomthre_hotelmob_details').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
					$('#roomthre_hotelmob_details').find('.child-nos .input-group--btn .plus').attr('disabled', true);
				}
				else
				{
					$('#roomthre_hotelmob_details').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
					$('#roomthre_hotelmob_details').find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
		}
	}

	/**
	 * @function passengerDetailsFlightHotel
	 * !!! Properly scoped
	 */

	passengerDetailsFlightHotel(): void {
		let _self = this;
		let $ticketAdultInput:number   = 1;
		//let $ticketYouthInput:number = 0;
		let $ticketChildInput:number   = 0;
		let $ticketInfantInput:number  = 0;
		let $totalTickets:number       = 1;
		let $totalPassenger:any 	  = _self.$instance.find('.mob-flight-container .total-passengers');
		let $ticketAdultInput_roomf:number  = 1;
		let $ticketAdultInput_rooms:number  = 1;
		let $ticketAdultInput_roomt:number  = 1;
		let $ticketChildInput_roomf:number  = 0;
		let $ticketChildInput_rooms:number  = 0;
		let $ticketChildInput_roomt:number  = 0;
		let $ticketInfantInput_roomf:number  = 0;
		let $ticketInfantInput_rooms:number  = 0;
		let $ticketInfantInput_roomt:number  = 0;
		let curInstance = _self.$instance.find('.mob-flight-container'); // assign current instance to var as later requests will call latest assigned instance
		let $groupBooking     = curInstance.find('.group-booking');

		$totalPassenger.find('.total-nos').html($totalTickets);
		_self.$instance.find('.mob-flight-container input.total-tickets--value').val($totalTickets);
		
		$('.mob-flight-container .close-bookingroom2').on('click', () => {
			if($('#roomthre_details').hasClass('hide'))
			{
				$('#roomtwo_mob_details').css({ 'display': 'none' });
				$('.mob-flight-container .ticket-mob-adult--input2').val('0');
				$('.mob-flight-container .ticket-infant--input2').val('0');
				$('.mob-flight-container .ticket-mob-child--input2').val('0');
				$('#roomtwo_mob_details').find('.booking-ticket--nosr').remove();
				$('.mob-flight-container .close-bookingroom2').addClass('hide');
				updateTicketQtys();
			}
			$('.mob-flight-container .add_rooms').show();
		});
		$('.mob-flight-container .close-bookingroom3').on('click', () => {
			$('#roomthre_mob_details').css({'display': 'none' });
			$('.mob-flight-container .add_rooms').show();
			$('.mob-flight-container .ticket-mob-adult--input3').val('0');
			$('.mob-flight-container .ticket-infant--input3').val('0');
			$('.mob-flight-container .ticket-mob-child--input3').val('0');
			$('#roomthre_mob_details').find('.booking-ticket--nosr').remove();
			$('.mob-flight-container .close-bookingroom2').removeClass('hide');
			updateTicketQtys();
		});

		_self.$instance.find('.mob-flight-container .add_rooms').on('click', function(e:any) {
			e.preventDefault();
			if ($("#roomtwo_mob_details").css('display') == 'none')
			{
				$('#roomtwo_mob_details').css({'display': 'block' });;
				$('#roomtwo_mob_details').removeClass('hide');
				$('.ticket-mob-adult--input2').val('1');
				$('.mob-flight-container .close-bookingroom2').removeClass('hide');
				curInstance.find('.booking-ticket--nos .age-label').show();
				updateTicketQtys();
			}
			else
			{
				$('#roomthre_mob_details').removeClass('hide');
				$('#roomthre_mob_details').css({'display': 'block' });;
				curInstance.find('.booking-ticket--nos .age-label').show();
				$('.mob-flight-container .close-bookingroom2').addClass('hide');
				$('.ticket-mob-adult--input3').val('1');
				$('.mob-flight-container .add_rooms').hide();
				updateTicketQtys();
			}

		});
		_self.$instance.find('.mob-flight-container .mobile-ticketnos--btn').on('click', function(e:any){
			e.preventDefault();
			let $passengerDetailsActive:any = curInstance.find('[data-mob-mholidays-passenger-details-selected]');

			// declare passenger input variables
			// scope them to prevent multiple elements from being retrieved
			// (deals component uses the same class name for its inputs)
			let $adultInput  = $passengerDetailsActive.find('.ticket-mob-adult--input');
			let $infantInput = $passengerDetailsActive.find('.ticket-mob-infant--input');
			let $childInput = $passengerDetailsActive.find('.ticket-mob-child--input');
			// let $youthInput  = _self.$passengerDetailsActive.find('.ticket-mob-youth--input');

			let $adultBookingErr  = curInstance.find('.adult-booking--error---mobile');
			let $infantBookingErr = curInstance.find('.infant-booking--error---mobile');


			// get currently acted on input field
			var fieldName   = $(this).attr('data-field'),
			type        = $(this).attr('data-type'),
			input       = curInstance.find("input[name='"+fieldName+"']"),
			currentVal   = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
				if (type == 'minus') {
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
					}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
				} else if (type == 'plus') {
					if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
					}
					if (parseInt(input.val()) == input.attr('max')) {
						$(this).attr('disabled', true);
					}
				}
			} else {
				input.val(0);
			}
			if (!isNaN(currentVal) && fieldName=="passengersChildren" ||fieldName=="passengersChildren2"||fieldName=="passengersChildren3") {
				// show age box if hide
				let room_var=fieldName;
				var currentChild = currentVal+1;
				var currentChildmnus = currentVal-1;
				//flight-container
				$('.mob-flight-container .child-age-grp'+room_var).show();
				// $('.mob-flight-container .child-age-grp').show();
				if (type == 'minus') {
					if(currentChildmnus%8 ==0){
						$( ".mob-flight-container #child-age-col"+room_var+currentChildmnus ).remove();
						// $( ".mob-flight-container #child-age-col"+currentChildmnus ).remove();

					}else{
						//Append box
						$('.mob-flight-container #child-age-select'+room_var+currentVal).empty();
						// $('.mob-flight-container #child-age-select'+currentVal).empty();
					}
				} else if (type == 'plus') {
					if(currentVal%8 ==0){
						// Append column
						let ageLabel ='';
						let errorChildAge ='';
						if(currentChild == 1){
							ageLabel ='Age';
							errorChildAge ='<div class="child-age-error" data-childage-limit-mob="Child/Teenager age must be between 2 and 17" data-childage="Child/Teenager age is missing" style="display: none;">Please enter child/teenager age</div>';
						}
						var col1 =currentChild;
						var col2 =currentChild+1;
						var col3 =currentChild+2;
						var col4 =currentChild+3;
						var col5 =currentChild+4;
						var col6 =currentChild+5;
						var col7 =currentChild+6;
						var col8 =currentChild+7;
						var col9 =currentChild+9
						let $childAgeList ='<div class="col-lg-12 col-md-12 col-sm-12" id="child-age-col'+room_var+currentVal+'">'
						+'<div class="col-lg-12 col-md-12 col-sm-12 booking-ticket--nosr adult-nos child-age-drp"> <div class="child-age-label">Age of Children/Teenager</div>'
						+ errorChildAge
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col1+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col2+'"> '
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col3+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col4+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col5+'"> '
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col6+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col7+'"> '
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col8+'">'
						+'	</div>'
						+'	<div class="row child-age-select" id="child-age-select'+room_var+col9+'">'
						+'	</div>'
						+'</div>'
						+' </div>'
						
						// $('.mob-flight-container #child-age-grp').append($childAgeList);	
						// $('.mob-flight-container #child-age-select'+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('.mob-flight-container #child-age-grp'+room_var).append($childAgeList);	
						$('.mob-flight-container #child-age-select'+room_var+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child/Teenager '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option  "selected" value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					}else{
						//Append box
						// $('.mob-flight-container #child-age-select'+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('.mob-flight-container #child-age-select'+room_var+currentChild).append('<div class="col-lg-5 col-md-5 col-sm-5"><label class="booking-form--title1" for="childCount"> Child/Teenager '+currentChild+'</label></div>'
						+'<div class="col-lg-6 col-md-6 col-sm-6"><select id="childAgeInput'+currentChild+'" name="childAgeInput"><option "selected" value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
					}
				}
				else{
					$('.flight-container #child-age-select'+room_var+currentChild).append('');
				}
			}
		});

		// disable user input on field (next statement will no longer have any effect)
			curInstance.find('.minus-plus-input').attr('readonly', true);
		// store current value of input to data-attribute on focus
		// in case user manually edits fields
			_self.$instance.find('.mob-flight-container .minus-plus-input').focusin(function(){
				$(this).data('oldValue', $(this).val());
			});

		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('.mob-flight-container .minus-plus-input').on('change', function() {
			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');
				if (valueCurrent >= minValue) {
					curInstance.find(".mobile-ticketnos--btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
				} else {
				$(this).data('oldValue',$(this).val());
				}
				if (valueCurrent <= maxValue) {
					curInstance.find(".mobile-ticketnos--btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
				} else {
				$(this).data('oldValue',$(this).val());
				}
			updateTicketQtys();
			});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
			_self.$instance.find('.mob-flight-container .minus-plus-input').keydown(function (e:any) {
				if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
					(e.keyCode == 65 && e.ctrlKey === true) ||
					(e.keyCode >= 35 && e.keyCode <= 39)) {
					return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});
		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		updateTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[data-mob-mholidays-passenger-details-selected]');

			// get current values in input field and assign to method vars
			$ticketAdultInput_roomf = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input').val());
			$ticketAdultInput_rooms = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input2').val());
			$ticketAdultInput_roomt = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input3').val());
			$ticketChildInput_roomf = parseInt($passengerDetailsActive.find('.ticket-mob-child--input').val());
			$ticketChildInput_rooms = parseInt($passengerDetailsActive.find('.ticket-mob-child--input2').val());
			$ticketChildInput_roomt = parseInt($passengerDetailsActive.find('.ticket-mob-child--input3').val());
			$ticketInfantInput_roomf = parseInt($passengerDetailsActive.find('.ticket-infant--input').val());
			$ticketInfantInput_rooms = parseInt($passengerDetailsActive.find('.ticket-infant--input2').val());
			$ticketInfantInput_roomt = parseInt($passengerDetailsActive.find('.ticket-infant--input3').val());

			// get current values in input field and assign to method vars
			$ticketAdultInput = $ticketAdultInput_roomf +$ticketAdultInput_rooms + $ticketAdultInput_roomt;
			$ticketInfantInput = $ticketInfantInput_roomf +$ticketInfantInput_rooms + $ticketInfantInput_roomt;
			$ticketChildInput = $ticketChildInput_roomf +$ticketChildInput_rooms + $ticketChildInput_roomt;

			//$ticketInfantInput = parseInt($passengerDetailsActive.find('.ticket-mob-infant--input').val());

			// only adult and child tickets count towards limit
			$totalTickets = $ticketAdultInput + $ticketInfantInput + $ticketChildInput;
			let $totalPassengersVal:any = $totalTickets;
			let $totalPassenger:any 	  = curInstance.find('.total-passengers');
			//let $totalTravelerDisplay:any = curInstance.find('.total-passengers');

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('.mob-flight-container .total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			//$totalPassenger.find('.total-nos').html($totalPassengersVal);
			//$totalTravelerDisplay.find('.total-nos').html($totalPassengersVal);

			if ($totalTickets >= 2) {
				$totalPassenger.find('.type').html('Travellers');
			} else {
				$totalPassenger.find('.type').html('Traveller');
			}
			if($ticketInfantInput==3)
			{
				curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
			}
			else
			{

					if ($ticketAdultInput_roomf == $ticketInfantInput_roomf) 
					{
						$('#roomone_details_mob').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_roomf <$ticketInfantInput_roomf)
					{
						$('#roomone_details_mob').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomone_details_mob').find('.ticket-infant--input').val($ticketAdultInput_roomf);
					}
					else
					{
						$('#roomone_details_mob').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}


					if ($ticketAdultInput_rooms == $ticketInfantInput_rooms) 
					{
						$('#roomtwo_mob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_rooms <$ticketInfantInput_rooms)
					{
						$('#roomtwo_mob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomtwo_mob_details').find('.ticket-infant--input').val($ticketAdultInput_rooms);
					}
					else
					{
						$('#roomtwo_mob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}


					if ($ticketAdultInput_roomt == $ticketInfantInput_roomt) 
					{
						$('#roomthre_mob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
					} 
					else if ($ticketAdultInput_roomt <$ticketInfantInput_roomt)
					{
						$('#roomthre_mob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', true);
						$('#roomthre_mob_details').find('.ticket-infant--input').val($ticketAdultInput_roomt);
					}
					else
					{
						$('#roomthre_mob_details').find('.infant-nos .input-group--btn .plus').attr('disabled', false);
					}
				}
			let $totalPassengersValnew: any =$ticketAdultInput  + $ticketChildInput;
			if ($totalPassengersValnew >= 9) {
				// $groupBooking.show();
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.add_rooms').css({ 'opacity': '0.5','pointer-events': 'none' });
				// curInstance.find('.youth-nos .input-group--btn .plus').attr('disabled', true);
				// curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
			} else {
				curInstance.find('.add_rooms').css({ 'opacity': '1','pointer-events': 'auto' });
				$groupBooking.hide();
				if ($ticketAdultInput >= 9) {
					curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				} else {
					curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				}
				if ($ticketChildInput >= 6) {
					curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
				} else {
					curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', false);
				}
				// curInstance.find('.youth-nos .input-group--btn .plus').attr('disabled', false);
				// curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', false);
			}
		}
	}

	/**
	 * @function merciSubmitFormHandler
	 * !!! Properly scoped
	 */
	merciSubmitFormHandler(): void {
		let _self = this;
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let initMerciFormSubmit:any = function() {
	    let $screenSize:any = $(window).width();
	    if ($screenSize < 768) {
	      // console.log("Mobile screen");
			let del=_self.getOfficeCode();

				_self.$instance.find('.mobile-mholiday-form-submit').off('click.submit-mobile-booking').on('click.submit-mobile-booking', (evt:any) => {
					evt.preventDefault();
					adobeDataLayer.push('click', {
						'clickName': 'click:btn-click:flight-and-hotel-search',
						'componentType': 'btn',
						'componentName': 'Flight And Hotel Search Button',
						'componentID': '',
						'attributes': []
					});
					_self.bookingFormSubmit.mholidaysMobileBookingFormValidation(curInstance, _self.$officeCode, function($officeCode:any){
						_self.bookingFormSubmit.mobileMholidaysDeeplink(curInstance);
					});
				});
				_self.$instance.find('.mobile-mholiday-hotel-submit').off('click.submit-mobile-booking').on('click.submit-mobile-booking', (evt:any) => {
					evt.preventDefault();
					_self.bookingFormSubmit.mholidaysMobileHotelValidation(curInstance, _self.$officeCode, function($officeCode:any){
						_self.bookingFormSubmit.mobileMholidaysHotelDeeplink(curInstance);
					});
				});
	    } else { //if(widowWidth <= 767)
	      // console.log("Desktop screen");
	    }
		};

		$(window).resize(initMerciFormSubmit);
		initMerciFormSubmit();
	}

	/**
	 * @function getOfficeCode
	 * !!! Properly scoped
	 */
	getOfficeCode(): void {
		let _self = this;

		let setOfficeID = function ($fromOfficeID:any) {
			_self.$officeCode = $fromOfficeID;
		};

		_self.$instance.find('.ibe-mob-from--location').change(function (e:any) {
			let $pickerID = e.target.id;
			let $selected = $(this).find(":selected");
			// let $selected_val = $selected.val();
			let $selected_text = $selected.text();
			// let $fromOfficeID = $(this).parent().find('.selectize-dropdown-content .option.selected').parent().attr('data-group');
			let $fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",")+1,$selected_text.indexOf("(")).replace(/\s+/g,"");
			setOfficeID($fromOfficeID);
		});
	}


	/**
	 * pre-populate ibe on load with data attached via data-attributes
	 * only for MOBILE ibe
	 * 
	 *
	 * 2018/03/20 update:
	 * - extend method to accept params (data,instance) to manually invoke and
	 *   populate topnav ibe for deep link
	 */
	populateOnload(data?:ibeTripData, instance?:any): void {
		let _self = this;
		let tripData:ibeTripData = {};

		// use current instance and dataset of instance if not passed into method
		if (instance === undefined) {
			instance = _self.$instance;
		}

		if (data === undefined) {
			tripData = _self.$instance.data();

			// cast date params as string
			if (tripData.fromDate) {
				tripData.fromDate = tripData.fromDate.toString();
			}
			if (tripData.toDate) {
				tripData.toDate = tripData.toDate.toString();
			}
		} else {
			tripData = data;
		}

		// trip type (set first as current behavior wipes input fields after change)
		// use promise to determine completion before setting other fields
		// no namespace on click for mobile
		let tripTypeSet = $.Deferred();

		switch (tripData.triptype) {
			case 'R':
			case 'return':
				instance.find('.trip-type--container .returnTrip').trigger('click', tripTypeSet.resolve(tripData.triptype));
				break;
			case 'O':
			case 'oneway':
				instance.find('.trip-type--container .oneWayTrip').trigger('click', tripTypeSet.resolve(tripData.triptype));
				break;
			case 'M':
			case 'multicity': // no multicity for mobile
			default:
				tripTypeSet.resolve('R'); // retain default (return) and resolve promise
				break;
		}

		tripTypeSet.promise();

		$.when(tripTypeSet).done((triptype:string) => {
			// payment type (set before OnD)
			// if multicity flow is set, don't change payment type to miles
			let $paymentTypeInput = instance.find('.payment-method-options');
			switch (tripData.paymentType) {
				case 'C':
				case 'cash':
					$paymentTypeInput.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true).click();
					break;
				case 'M':
				case 'miles':
					if (triptype !== 'M') {
						$paymentTypeInput.find('input[name="cash_miles_type"][value="miles"]').prop('checked', true).click();
					}
					break;
				case 'CM':
				case 'cash_miles':
					if (triptype !== 'M') {
						$paymentTypeInput.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', true).click();
					}
					break;
				default:
					break;
			}

			// ond fields
			switch (triptype) {
				case 'R':
				case 'return':
				case 'O':
				case 'oneway':
					// assign "to location" value to prepop into class variable
					// (to await completion of updating "from location")
					// following which the "to location" value will be populated
					if (tripData.toLoc !== undefined) {
						_self.toPrepop = tripData.toLoc;
					}

					// from location (selectize instance)
					if (tripData.fromLoc !== undefined) {
						let $fromLocationInput = instance.find('select.ibe-mob-from--location')[0].selectize;
						$fromLocationInput.setValue(tripData.fromLoc);
					}
					break;
				case 'M':
				case 'multicity': // no multicity for mobile
				default:
					break;
			}

			// passengers input
			// populate values into input fields and trigger change to update displayed total value
			// adult
			if (tripData.psgAdult !== undefined) {
				let $psgAdultInput = instance.find('.minus-plus-input[name="passengersAdult"]');
				$psgAdultInput.val(parseInt(tripData.psgAdult)).trigger('change');
			}

			// child
			if (tripData.psgChild !== undefined) {
				let $psgChildInput = instance.find('.minus-plus-input[name="passengersChildren"]');
				$psgChildInput.val(parseInt(tripData.psgChild)).trigger('change');
			}

			// infant
			if (tripData.psgInfant !== undefined) {
				let $psgInfantInput = instance.find('.minus-plus-input[name="passengersInfant"]');
				$psgInfantInput.val(parseInt(tripData.psgInfant)).trigger('change');
			}

			/**
			 * test validity of date value for single trip
			 * criteria:
			 * - not undefined
			 * - string length > 0
			 * - string does not contain commas (multicity)
			 * @param {string} testString
			 */
			let validSingleDate = function (testString:string) {
				return (testString !== undefined && testString.length > 0 && testString.indexOf(',') < 0);
			};

			// travel dates (set last, should only happen after trip type has been set)
			// set date (format using moment and populate val) and trigger blur to set input field focus state
			// if trip type is return/oneway, don't populate datefields if multicity format is detected (comma present)
			switch (triptype) {
				case 'R':
				case 'return':
					// from date
					if (validSingleDate(tripData.fromDate)) {
						let $fromDateInput = instance.find('.returnTrip .departureDateMobile');
						$fromDateInput.val(moment(tripData.fromDate, 'YYYYMMDD').format('DD MMM YYYY')).trigger('blur', 'input');
					}
					// to date
					if (validSingleDate(tripData.toDate)) {
						let $toDateInput = instance.find('.returnTrip .returnDateMobile');
						$toDateInput.val(moment(tripData.toDate, 'YYYYMMDD').format('DD MMM YYYY')).trigger('blur', 'input');
					}
					break;

				case 'O':
				case 'oneway':
					// oneway from date
					if (validSingleDate(tripData.fromDate)) {
						let $owFromDateInput = instance.find('.oneWayTrip .departureDateMobile');
						$owFromDateInput.val(moment(tripData.fromDate, 'YYYYMMDD').format('DD MMM YYYY')).trigger('blur', 'input');
					}
					break;

				case 'M':
				case 'multicity': // no multicity for mobile
				default:
					break;
			}

			// cabin class
			let $cabinClassInput = instance.find('select.cabin-class-mob')[0].selectize;
  		switch (tripData.cabinType) {
  			case 'F':
  			case 'CFFFIRST':
  				$cabinClassInput.setValue('CFFFIRST');
	  			break;
  			case 'B':
  			case 'CFFBUS':
  				$cabinClassInput.setValue('CFFBUS');
	  			break;
  			case 'E':
  			case 'CFFECO':
  				$cabinClassInput.setValue('CFFECO');
	  			break;
	  		default:
	  			break;
  		}

  		// coupon code
  		let $couponCodeInput = instance.find('[name="couponcode"]');
  		if (tripData.couponCode !== undefined) {
  			$couponCodeInput.val(tripData.couponCode).trigger('blur');
  		}
		});
	}

	/**
	 * fill prepop value to this select if waiting prepop value is present
	 */
	fillToPrepopValue(el:any):void {
		let _self = this;
		let val = _self.toPrepop;

		if (val) {
			el.setValue(val);
			_self.toPrepop = null;
		}
	}

}

let scope:Element = document.querySelector('[data-mob-mholidays--book-flight]');
if (scope){
	try {
		let mobbookflight = new mobileBookingFormContent();
		let bookingformcommon = new bookingFormCommon();
		let bookflightinfant = new bookingFormInfant();
		var adobeDataLayer = new adobeDataLayerWrapper();
		bookingformcommon.populateTuiHotelList($('#mobile-mholidays--container'));
		// start: init navbar behavior
		mobbookflight.nav();
		mobbookflight.init();
		// end: init navbar behavior

		// mobile ibe
		let mobileIBEs:any = document.querySelectorAll('[data-mob-mholidays--book-flight]');
		let numDesktopIBEs:number = mobileIBEs.length - 1;
		let lastOnDDone:any = $.Deferred();

		Array.prototype.map.call(mobileIBEs, function(instance:any, i:number) {
			$.when(window['mHolidaysOnDList']).done((listData: any) => {
				mobbookflight.setInstance(instance);
				mobbookflight.merciSubmitFormHandler();
				mobbookflight.getOfficeCode();
				mobbookflight.ibeTripType();
				mobbookflight.calendarComponent();
				mobbookflight.passengerDetailsHotel();
				mobbookflight.passengerDetailsFlightHotel();
				mobbookflight.passengerType();
				let listItems:string = bookingformcommon.parseOnDListItems(listData, 'mholiday');

				mobbookflight.initSelectize(listItems);
				bookflightinfant.toggleSubmitBtnDisplay(instance);
				mobbookflight.populateOnload();
				if (numDesktopIBEs == i) {
					lastOnDDone.resolve();
				}
			});
		});

		lastOnDDone.promise();

		$.when(lastOnDDone).done(() => {
			//mobbookflight.deeplink();
		});


	} catch(e) {console.error(e);}
}
